<template>
	<section>
		<b-col v-show="!hideSelectSendMsg" class="text-parcela">
			<label class="label-conta mb-0">Ativar mensagem cobrança</label>
			<div style="display: flex !important; align-items: center; margin-top: -4px !important;">
				<div class="toggle-div mr-3">
					<ToggleSwitch
						name="sendMsg"
						class="toggle"
						:value="sendMsg"
						@toggle="_ => changeToggle('sendMsg')"
					/>
				</div>
			</div>
		</b-col>
        <div v-if="installments.length" class="table-wrapper mt-3" style="max-height: 13rem !important;">
            <table class="class-table" style="width: calc(100% - 8px); min-width: 150px; max-height: 2rem !important;">
                <thead class="class-th">
                    <tr>
                        <th class="pt-2 border-left" style="width: 20%;">
                            <label class="ml-2">Vencimento</label>
                        </th>
                        <th class="pt-2 border-left" style="width: 30%;">
                            <label class="ml-2">Valor</label>
                        </th>
                        <th class="pt-2 border-left" style="width: 50%;">
                            <label class="ml-2">Referência</label>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(installment, index) in installments" :key="index">
                        <td class="pl-2 pr-2 class-td" style="width: 20%;" v-bind:class="installment.paymentDate !== (JSON.parse(installmentsOriginal))[index].paymentDate ? 'orange' : ''">
                            <b-form-input class="pt-0 pb-0 edicao-input center-class no-validation-icon"
                                :name="`date-${index}`"
                                v-model="installment.paymentDate"
                                v-validate="'required|isDate'"
                                :state="validateState(`date-${index}`)"
                                :disabled="installment.paid"
                                @blur="validateDate(index)"
                                autocomplete="off"
                                maxlength="10"
                            />
                        </td>
                        <td class="class-td" style="width: 30%;" v-bind:class="installment.amount !== (JSON.parse(installmentsOriginal))[index].amount ? 'orange' : ''">
                            <b-form-input
                                :name="`amount-${index}`"
                                class="pl-2 pr-2 pt-0 pb-0 edicao-input number-class no-validation-icon"
                                v-model="installment.amount"
                                autocomplete="off"
                                placeholder=""
                                :state="validateState(`amount-${index}`)"
                                v-validate="'required|noZeroCurrency'"
                                inputmode="numeric"
                                :disabled="installment.paid"
                                @input="updateValue(index)"
                            />
                        </td>
                        <td class="class-td" style="width: 50%;" v-bind:class="installment.reference !== (JSON.parse(installmentsOriginal))[index].reference ? 'orange' : ''">
                            <b-form-input class="pl-2 pr-2 pt-0 pb-0 edicao-input no-validation-icon"
                                :name="`reference-${index}`"
                                v-model="installment.reference"
                                v-validate="validateState(`reference-${index}`)"
                                :state="validateState(`reference-${index}`)"
                                :disabled="false"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</template>

<script>
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { validateNumber } from "@/helpers/common";
	import ToggleSwitch from "@/components/ToggleSwitch.vue";

	export default {
		name: "InstallmentEdit",
		components: {
			ToggleSwitch
		},
		props: {
			dataEdit: {
				type: Array,
				required: true
			},
			hideSelectSendMsg: {
				type: Boolean,
				required: false,
				default: false
			},
			sendLatePaymentMessage: {
				type: Boolean,
				required: false,
				default: false
			}
		},

		data () {
			return {
				installments: [],
				installmentsOriginal: JSON.stringify(this.dataEdit),
				invalidForm: false,
				sendMsg: false
			};
		},

		mounted () {
			this.sendMsg = this.sendLatePaymentMessage;
			this.installments = this.dataEdit.map(installment => installment);
			this.emitDataInstallment();
		},

		methods: {
			validateState (ref) {
				this.invalidForm = hasFieldsWithErrors(this.veeFields);
				this.$emit("invalidData", this.invalidForm);

				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				this.emitDataInstallment();

				return null;
			},

			async updateValue (index) {
				this.installments[index].amount = await validateNumber(this.installments[index].amount);
			},

			async validateDate (index) {
				const value = this.installments[index].paymentDate;
				const regex = /^([0-2][0-9]|(3)[0-1])-(0[1-9]|1[0-2])-\d{4}$/;

				let isValueDate = null;
				if (!regex.test(value)) {
					isValueDate = false;
				} else {
					const [day, month, year] = value.split("-");
					const date = new Date(year, month - 1, day);
					isValueDate = date.getDate() == day && date.getMonth() + 1 == month && date.getFullYear() == year;
				}
				if (!isValueDate && value) {
					const dateString = value.replace(/[^0-9-]/g, "");
					this.installments[index].paymentDate = dateString;
				}
			},

			emitDataInstallment () {
				const data = { dataEdited: this.installments, sendMsg: this.sendMsg};
				this.$emit("dataEditInstallments", data);
			},
			changeToggle (key) {
				this[key] = !this[key];
				this.emitDataInstallment();
			}
		}
	};
</script>

<style scoped>
	.no-validation-icon.is-valid,
	.no-validation-icon.is-invalid {
		background-image: none !important;
		padding-right: 0.75rem !important;
	}

	.orange {
		border: 2px solid orange !important;
	}

	.no-click {
		pointer-events: none;
	}

	.edicao-input {
		border: 1px solid white;
		color: black;
	}

	.class-table {
		border: 1px solid rgb(126, 124, 124);
		border-collapse: collapse;
	}

	.class-th {
		background-color: var(--cal-navbar-bg);
		color: white;
		position: sticky;
		top: -1px;
		z-index: 1;
	}

	.border-left {
		border-left: white;
	}

	.border-right {
		border-right: white;
	}

	.class-td {
		border: 1px solid rgb(180, 179, 179);
		color: black;
	}

	.table-wrapper {
		max-height: 58vh;
		overflow: auto !important;
		border: 1px solid rgb(180, 179, 179);
	}
</style>

